import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import classNames from 'classnames';
import { formatCurrency } from '../../../../helpers/format';
import { isMobile, isMobileLandscape } from 'react-device-detect';
import { getTournaments, getTournamentPlayers } from '../../../../store/selectors';
import { useTranslation } from 'react-i18next';
import prize from '../../../../assets/images/prize.png'
import '../../../../assets/stylesheets/Dialogs/TournamentFinished.scss'


const TournamentOutOfSpins = ({ data, onClose, onConfirm, onCloseDialog, isFinish }) => {
  const {data: dataInfo, tournamentId} = data;
  const { t } = useTranslation();

  {/* will translate 'Back to Tournament Lobby'  */}
  {/* will translate 'Back to Tournament List'  */}
  const BTN_NAMES_AFTER_GAMES = {
    // confirm: t('backToLobby'),
    // cancel: t('backToTourList'),
    cancel: t('ok'),
  };
  const BTN_NAMES_AFTER_TOURNAMENT = {
    confirm: t('tournaments.tournamentLobby'),
  };

  const tournaments = useSelector(getTournaments);
  const tournamentPlayers = useSelector(getTournamentPlayers);
  // const user = useSelector(getUser);
  // let player = data.tournamentId in tournamentPlayers && user ? tournamentPlayers[data.tournamentId].find(p => p.name === user.username) : null;
  let player = null; // TODO GET correct Player name 
  if (!player) player = { score: dataInfo.score, place: dataInfo.playerPosition };
  let isTourLobbyAvailable = tournaments.filter(t => t.tournamentId === tournamentId).length;

  const tourPrizepoolResults = (
    <div className="tour-results-prizepool">
      <div className="tour-results-prizepool__image-container">
        <img className="tour-results-prizepool__image" src={prize} alt="Congrats"/>
      </div>
      <div className="tour-results-prizepool__info-container">
        <span className="tour-results-prizepool__info-text">{`${t('tournaments.youWon')}:`}</span>
        <span className="tour-results-prizepool__info-win-amount">
          { !!dataInfo.winning && dataInfo.winning.amount > 0 && formatCurrency(dataInfo.winning.amount, '', dataInfo.winning.currency) }
        </span>
      </div>
    </div>
  )


  const outOfSpinsOptions = {
    afterGameDialogOptions: {
      afterGameProps: {
        iconName: 'outOfSpins',
        btnNames: BTN_NAMES_AFTER_GAMES,
        bodyClassName: 'tournaments__dialog-finish__body',
        onClose,
        onConfirm,
        onCloseDialog,
      },
      afterGameContent: {
        title: t(`tournaments.messages.game_finished`),
      }
    },

    afterTournamentDialogOptions: {
      afterTournamentProps: {
        className: 'tournament__finish-dialog-body',
        iconName: 'congrats',
        btnNames: BTN_NAMES_AFTER_TOURNAMENT,
        bodyClassName: 'tournaments__dialog-finish__body',
        onClose,
        onConfirm: isTourLobbyAvailable ? onConfirm : onClose
      },
      afterTournamentContent: {
        title: t(`tournaments.messages.tournament_finished`),
        // subtitle: t('theTournament') + data.tournamentName + " | " + t('id') + ":" + data.tournamentId + t('hasEnded'),
        subtitle: t('messages.tourFinished.body'),
        tourPrizepoolResultsContent: tourPrizepoolResults,
        containerClassName: 'congrats'
      }
    }
  }

  let outOfSpinsProps;
  let outOfSpinsContent;

  const {afterGameDialogOptions: {afterGameProps}, afterTournamentDialogOptions: {afterTournamentProps}} = outOfSpinsOptions;
  const {afterGameDialogOptions: {afterGameContent}, afterTournamentDialogOptions: {afterTournamentContent}} = outOfSpinsOptions;

  if (isFinish) {
    outOfSpinsProps = afterTournamentProps || {};
    outOfSpinsContent = afterTournamentContent || {};
  } else {
    outOfSpinsProps = afterGameProps || {};
    outOfSpinsContent = afterGameContent || {};
  }

  const {title, subtitle, tourPrizepoolResultsContent, containerClassName} = outOfSpinsContent;

  const tournamentDialogFinishClassNames = classNames({
    'tournaments__popup': true,
    'tournaments__dialog-finish': true,
    'tournaments__dialog-finish--mobile': isMobile && !isMobileLandscape,
    'tournaments__dialog-finish--landscape': isMobileLandscape,
    'congrats': containerClassName
  })

  return (
    <>
      <div className={tournamentDialogFinishClassNames}>
        <div className="tournaments__popup__overlay" />
        <PopUpDialogTemplate {...outOfSpinsProps}>
          <div className="tournament__dialog-gold-text">{title}</div>
          {subtitle && <div className="tournament__dialog-gold-sub-text" >{subtitle}</div>}
          <div className="tour-results-wrapper">
            <div className={`tour-results ${containerClassName}-result-container`}>
              <div className="result-row">
                <span className="result-title">{t(`tournaments.yourScore`)}</span>
                <span className="result-number">{player.score}</span>
              </div>
              <div className="result-row">
                <span className="result-title">{t(`tournaments.yourPosition`)}</span>
                <span className="result-number">{player.place}</span>
              </div>
            </div>
            { !!dataInfo.winning && dataInfo.winning.amount > 0 && tourPrizepoolResultsContent }
          </div>
        </PopUpDialogTemplate>
      </div>
    </>
  )
}

export default TournamentOutOfSpins;
